import {
  NewButton,
  NewButtonVariant,
  TooltipTrigger,
} from "@visiblethread/react-components";
import { FileStack } from "lucide-react";
import { bool, string } from "prop-types";

import useCombineDocuments from "../../hooks/useCombineDocuments";

const COMBINE_PURPOSE =
  "Composes all written documents into the final proposal";

const CombineDocumentsButton = ({ disabled = false, disabledReason = "" }) => {
  const onClick = useCombineDocuments();

  return (
    <TooltipTrigger
      content={(disabled && disabledReason) || COMBINE_PURPOSE}
      delay={1000}
    >
      <NewButton
        data-testid="combine-outline-btn"
        disabled={disabled}
        leftIcon={<FileStack size={16} />}
        onClick={onClick}
        variant={NewButtonVariant.l2}
      >
        Combine Into One Document
      </NewButton>
    </TooltipTrigger>
  );
};

CombineDocumentsButton.propTypes = {
  disabled: bool,
  disabledReason: string,
};

export default CombineDocumentsButton;
